export const homeObjOne = {
    id: 'about',
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    topLine: '',
    headLine: 'O Stowarzyszeniu',
    description: 'Stowarzyszenie Sądecki Elektryk realizuje wiele projektów, które angażują uczniów i pozwalają im zaprezentować swoje umiejętności jak i rozwijać swe pasje. Przez 8 lat swego istnienia Stowarzyszenie zrealizowało ponad 50 projektów.',
    buttonLabel: 'Zobacz projekty',
    imgStart: false,
    img: '../../images/contact.svg',
    alt: 'Logo',
    dark: true,
    primary: true,
    darktext: false,
    outside: 0,
    to: 'projects'
}

export const homeObjTwo = {
    id: 'contact',
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    topLine: '',
    headLine: 'Kontakt',
    description: '',
    buttonLabel: 'Skontaktuj się ze Stowarzyszeniem',
    imgStart: true,
    img: '../../images/contact.svg',
    alt: 'Kontakt',
    dark: true,
    primary: true,
    darktext: false,
    outside: 1,
    to: 'http://stowarzyszenie.zsem.edu.pl#content'
}


export const homeObjThree = {
    id: 'support1Per',
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    topLine: 'Wesprzyj Stowarzyszenie',
    headLine: 'Przekaż 1% podatku',
    description: 'Zarząd Stowarzyszenia Sądecki Elektryk zwraca się z prośbą do wszystkich członków i sympatyków stowarzyszenia, by przy wypełnianiu deklaracji podatkowej wnioskować o przekazanie 1% podatku na rzecz  Pallotyńskiej Fundacji Misyjnej Salvatti.pl  KRS 0000309499 ze wskazaniem w rubryce cel szczegółowy informacji: Sądecki Elektryk Celem łatwiejszego wypełnienia deklaracji podatkowej można skorzystać z aplikacji e-pity dostępnej na stronie Pallotyńskiej Fundacji Misyjnej Salvatti.pl pod adresem: ' ,
    buttonLabel: 'Wesprzyj',
    imgStart: false,
    img: '../../images/contact.svg',
    alt: 'Wesprzyj Stowarzyszenie',
    dark: true,
    primary: true,
    darktext: false,
    outside: 1,
    to: 'https://salvatti.pl/'
}

export const homeObjFour = {
    id: 'supportGift',
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    topLine: 'Wesprzyj Stowarzyszenie',
    headLine: 'Wpłać darowiznę',
    description: 'Stowarzyszenie możesz również wesprzeć poprzez wpłacenie darowizny na konto bankowe: Bank BGŻ BNP Paribas S.A 98 2030 0045 1110 0000 0387 2230',
    buttonLabel: 'Skopiuj numer konta bankowego',
    imgStart: true,
    img: '../../images/contact.svg',
    alt: 'Wesprzyj Stowarzyszenie',
    dark: true,
    primary: true,
    darktext: false,
    outside: 0,
    to: ''
}